import { Button } from "@/components/ui/button";
import { McpService } from "@/gen/omnios/v1/mcp_connect";
import { transport } from "@/lib/grpc";
import { createClient } from "@connectrpc/connect";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/auth/mcp-callback")({
	component: McpOAuthCallback,
});

const mcpClient = createClient(McpService, transport);

function McpOAuthCallback() {
	const [status, setStatus] = useState<"loading" | "success" | "error">(
		"loading",
	);
	const [error, setError] = useState<string>();
	const called = useRef(false);
	const { t } = useTranslation();

	useEffect(() => {
		if (called.current) return;
		called.current = true;

		const params = new URLSearchParams(window.location.search);
		const code = params.get("code");
		const state = params.get("state");

		if (!code || !state) {
			setStatus("error");
			setError(t("auth_code_missing"));
			return;
		}

		mcpClient
			.completeMcpOAuth({ state, code })
			.then(() => {
				setStatus("success");
				setTimeout(() => window.close(), 1500);
			})
			.catch((e) => {
				setStatus("error");
				setError(e instanceof Error ? e.message : t("auth_error"));
			});
	}, [t]);

	if (status === "success") {
		return (
			<div className="flex min-h-screen items-center justify-center">
				<div className="rounded-lg border border-green-200 bg-green-50 p-6 text-center">
					<p className="text-sm text-green-700">{t("mcp_connected")}</p>
				</div>
			</div>
		);
	}

	if (status === "error") {
		return (
			<div className="flex min-h-screen items-center justify-center">
				<div className="rounded-lg border border-red-200 bg-red-50 p-6 text-center">
					<p className="text-sm text-red-700">{error}</p>
					<Button
						variant="link"
						onClick={() => window.close()}
						className="mt-3 text-red-600"
					>
						{t("close")}
					</Button>
				</div>
			</div>
		);
	}

	return (
		<div className="flex min-h-screen items-center justify-center">
			<p className="text-sm text-slate-500">{t("mcp_connecting")}</p>
		</div>
	);
}
